export default __webpack_public_path__ + "static/media/yt-icon.ea07be1f.svg";